class OfficeStore {
  constructor(axios) {
    this.axios = axios
    this.state = {}
  }

  getOfficeApi() {
    this.state = Object.assign({}, this.state, { officeApi: {} })

    return this._loadOffice().then((data) => {
      this.state = Object.assign({}, this.state, { officeApi: data })
      return data
    })
  }

  login(username, password, sessionToken, platform) {
    return this.axios.post('msoffice/sessions', { platform: platform },
        {
            auth: { username: username, password: password },
            headers: { 'Session-Token': sessionToken }
        }
    ).then(({data}) => {
      this.state = Object.assign({}, this.state, { currentUser: data.user })
      this.state = Object.assign({}, this.state, { userDefaults: data.defaults })
    })
  }

  createAttachment(params, callbackToken) {
    return this.axios.post('msoffice/attachments',
        params, { headers: { 'Callback-Token': callbackToken } }
    )
  }

  logout() {
    return this.axios.delete('msoffice/sessions').then(() => {
      this.state = {}
    })
  }

  _loadOffice() {
      let count = 0
      let maxRetries = 10
      let delay = 200
      let forced = false

      return new Promise( function(resolve, reject) {
          function callFunc() {
            try
            {
              if(window.Office){ // try half first approach
                if(count < maxRetries/2) {
                  window.Office.onReady().then((data) => {
                    return resolve(data)
                  })
                }
                else { // try another half second approach
                  return window.Office.initialize = function(data){
                    if(data==="documentOpened"){
                      let diagnostic = window.Office.context.diagnostics
                      return resolve({
                        "host": diagnostic.host,
                        "platform": diagnostic.platform,
                        "addin": null
                      })
                    } else
                      throw new Error("OfficeJS: Second try not fully loaded yet")
                  }
                }
              } else
                throw new Error("OfficeJs: Not fully loaded yet")
            }
            catch(e)
            {
              if( ++count >= maxRetries){
                if(!forced){
                  forced = true
                  count = 0
                  forceLoadScript()
                  setTimeout(callFunc, delay)
                } else
                return reject(new Error("OfficeJs: Impossible load API"))

              } else
                setTimeout(callFunc, delay)
            }
          }

          function forceLoadScript(){
            let f = document.getElementsByTagName('script')[0],
                t = document.createElement('script')
            t.async = true
            t.src = 'https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js'
            f.parentNode.insertBefore(t, f)
          }

          return callFunc()
      })
  }
}

export default OfficeStore
